import React from "react";
import { Box, Typography } from "@mui/material";

const AboutUs = () => {
  return (
    <Box sx={{ p: 17, textAlign: "center" }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Customer Service Coming Soon
      </Typography>

      <Typography variant="h6" color="text.secondary">
        Development in Process
      </Typography>
    </Box>
  );
};

export default AboutUs;
